import { Injectable } from '@angular/core';
 
// Define the proper types for Quill modules
interface QuillKeyboardBinding {
  key: string | number;
  shiftKey?: boolean | null;
  handler: (this: any, range: any, context: any) => boolean;
}
 
interface QuillKeyboardModule {
  bindings: {
    [key: string]: QuillKeyboardBinding;
  };
}
 
interface QuillModulesConfig {
  toolbar: any[];
  imageResize?: {
    modules: string[];
  };
  keyboard?: QuillKeyboardModule;
}
 
@Injectable({
  providedIn: 'root'
})
export class QuillConfigService {
 
  getStandardQuillModules(): QuillModulesConfig {
    return {
      toolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link', 'image']
      ],
      imageResize: {
        modules: ['Resize', 'DisplaySize']
      },
      keyboard: {
        bindings: {
          'list autofill': {
            key: ' ',
            shiftKey: null,
            handler: function(this: any, range: any, context: any) {
              const quill = this.quill;
             
              // Get the current line
              const [line, offset] = quill.getLine(range.index);
              if (!line) return true;
             
              // Calculate where the line starts
              const lineStart = range.index - offset;
              const lineLength = line.length();
             
              // Get the text from the start of the line to current position
              const textBeforeSpace = quill.getText(lineStart, offset);
             
              // Match patterns: 1. or a. or A. or - or * or +
              const match = /^(\d+\.|[a-z]\.|[A-Z]\.|\-|\*|\+)$/.exec(textBeforeSpace.trim());
             
              if (match) {
                const listType = /^\d+\.$/.test(match[0]) ? 'ordered' : 'bullet';
               
                // Delete the pattern text (e.g., "1." or "-")
                quill.deleteText(lineStart, offset);
               
                // Format as list
                quill.formatLine(lineStart, 1, 'list', listType);
               
                // Prevent default space insertion
                return false;
              }
             
              return true;
            }
          },
          'outdent': {
            key: 'Tab',
            shiftKey: true,
            handler: function(this: any, range: any, context: any) {
              const quill = this.quill;
              const formats = quill.getFormat(range);
 
              if (formats.list && formats.indent > 0) {
                quill.format('indent', '-1', 'user');
              } else if (formats.list && formats.indent === 0) {
                quill.format('list', false, 'user');
              }
              return false;
            }
          },
          'enter': {
            key: 'Enter',
            handler: function(this: any, range: any, context: any) {
              const quill = this.quill;
              const [line, offset] = quill.getLine(range.index);
              const formats = quill.getFormat(range);
             
              if (formats.list && line.domNode.textContent.trim() === '') {
                quill.format('list', false, 'user');
                quill.format('indent', false, 'user');
                return false;
              }
             
              return true;
            }
          }
        }
      }
    };
  }
 
  getBasicQuillModules(): QuillModulesConfig {
    return {
      toolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link']
      ],
      keyboard: this.getStandardQuillModules().keyboard
    };
  }
}